import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Image as ImageLucide } from "lucide-react";
import { DrawingCanvas } from "@/components/media/DrawingCanvas";
import { toast } from "sonner";
import { useLocale } from "@/hooks/useLocale";
import type { ImageGenTabProps } from "./types";

export function DrawTab(props: ImageGenTabProps) {
  const { t } = useLocale();
  const {
    entity, currentImageUrl, generatedPreview, seedImageUrl,
    drawingInitialImage, setDrawingInitialImage,
    setDrawingDataUrl, saveDrawingToWorldMedia,
  } = props;

  // Auto-load the most relevant image as the drawing base when entering Draw
  useEffect(() => {
    if (drawingInitialImage) return;
    const auto = generatedPreview || currentImageUrl || entity.image_url || seedImageUrl;
    if (auto) setDrawingInitialImage(auto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">
        Create a sketch to guide AI generation. Your drawing will be used as a seed image.
      </p>
      {!drawingInitialImage && (currentImageUrl || entity.image_url || generatedPreview) && (
        <div className="flex gap-2 flex-wrap">
          {generatedPreview && (
            <Button variant="outline" size="sm" className="text-[11px] h-7 gap-1" onClick={() => setDrawingInitialImage(generatedPreview)}>
              <ImageLucide className="w-3 h-3" /> Load Generated
            </Button>
          )}
          {(currentImageUrl || entity.image_url) && (
            <Button variant="outline" size="sm" className="text-[11px] h-7 gap-1" onClick={() => setDrawingInitialImage(currentImageUrl || entity.image_url!)}>
              <ImageLucide className="w-3 h-3" /> Load Current
            </Button>
          )}
          {seedImageUrl && (
            <Button variant="outline" size="sm" className="text-[11px] h-7 gap-1" onClick={() => setDrawingInitialImage(seedImageUrl)}>
              <ImageLucide className="w-3 h-3" /> Load Seed
            </Button>
          )}
        </div>
      )}
      <DrawingCanvas
        width={768}
        height={768}
        initialImage={drawingInitialImage}
        onChange={(dataUrl) => {
          // Auto-save drawing state on every stroke so it survives dialog close
          setDrawingDataUrl(dataUrl);
        }}
        onExport={(dataUrl) => {
          setDrawingDataUrl(dataUrl);
          saveDrawingToWorldMedia(dataUrl);
          toast.success(t.draw_seed_saved);
        }}
      />
    </div>
  );
}
